import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import React, { useMemo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import useDoublePointsCampaignTier from '../hooks/useDoublePointsCampaignTier'

const TitleContainer = styled.div`
  &.platinum {
    color: ${props => props.theme.palette.neutral.default.eight};
  }
`

function DoublePointTakeoverTitleContent() {
  const intl = useIntl()
  const loyaltyProgramName = getLoyaltyProgramDisplayName()
  const [tier, tierName, , nextTierName] = useCurrentLoyaltyTier()
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const displayTier = useDoublePointsCampaignTier()
  const displayTierName = nextTierName ?? tierName

  const displayText = useMemo(() => {
    if (hasLoyaltyAccount) {
      if (tier === 'platinum') {
        return <FormattedMessage
          id="35DqZfznt6XibvxsPjAT"
          defaultMessage="Extend your <i>{displayTierName}</i> {loyaltyProgramName} status"
          description="Title for platinum members to extend their loyalty tier status"
          values={{ displayTierName, loyaltyProgramName, i: (chunks) => <i>{chunks}</i> }}
        />
      }
      return <FormattedMessage
        id="Z5Xynf30wUAVM8fjsNSv"
        defaultMessage="Fast-track to <i>{displayTierName}</i> {loyaltyProgramName} status"
        description="Title for members to fast-track to next loyalty tier"
        values={{ displayTierName, loyaltyProgramName, i: (chunks) => <i>{chunks}</i> }}
      />
    }

    return intl.formatMessage(
      {
        id: 'sHzAtOi2inrIaD8xiupQ',
        defaultMessage: 'Fast-track your {loyaltyProgramName} status',
        description: 'Title for non-members to fast-track their loyalty status',
      },
      { loyaltyProgramName },
    )
  }, [hasLoyaltyAccount, displayTierName, loyaltyProgramName, tier, intl])

  return (
    <TitleContainer className={displayTier}>
      {displayText}
    </TitleContainer>
  )
}

export default DoublePointTakeoverTitleContent
